import React from "react";

const SvgHamburger = props => <svg width={32} height={32} viewBox="0 0 32 32" fill="none" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M6 9H26V11H6V9ZM6 15H26V17H6V15ZM26 21H6V23H26V21Z" fill="currentColor" /></svg>;

export default "//cdn.scentbird.com/assets/frontbird-site/images/hamburger_dc2b24.svg";
export { SvgHamburger as ReactComponent };